import { Button, ButtonProps } from 'components/deprecated/Button';

interface Props extends ButtonProps {
  children: React.ReactNode;
}

export function AddInput({ children, ...rest }: Props): JSX.Element | null {
  return (
    <>
      <Button className="fullWidth" {...rest}>
        {children}
      </Button>
    </>
  );
}
